// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list_menu":"list_menu-14CsUn_2","morehNew":"morehNew-3bgzHF1g","more":"more-3D1lXE4j"};